module.exports = __webpack_public_path__ + "static/media/detailedTennisWhite.38a57413.svg";